// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1B3z3","inputWrap":"CustomTip_inputWrap__3ZNIt"};